import { Component, Injector, OnInit, ViewEncapsulation, NgZone, Input } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { NotificationServiceProxy, UserNotification } from '@shared/service-proxies/service-proxies';
import { IFormattedUserNotification, UserNotificationHelper } from './UserNotificationHelper';
import { forEach as _forEach } from 'lodash-es';
import { UrlHelper } from '@shared/helpers/UrlHelper';
import { DateTime } from 'luxon';

@Component({
    templateUrl: './header-notifications.component.html',
    selector: 'header-notifications',
    styleUrls: ['./header-notifications.component.less'],
    encapsulation: ViewEncapsulation.None,
})
export class HeaderNotificationsComponent extends AppComponentBase implements OnInit {
    notifications: IFormattedUserNotification[] = [];
    unreadNotificationCount = 0;

    duplicateCache: string[] = [];
    
    @Input() customStyle = 'btn btn-icon btn-active-light-primary position-relative w-30px h-30px w-md-40px h-md-40px me-2';
    @Input() iconStyle = 'flaticon-alert-2 unread-notification fs-4';

    constructor(
        injector: Injector,
        private _notificationService: NotificationServiceProxy,
        private _userNotificationHelper: UserNotificationHelper,
        public _zone: NgZone
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.loadNotifications();
        this.registerToEvents();
    }

    loadNotifications(): void {
        if (UrlHelper.isInstallUrl(location.href)) {
            return;
        }

        this._notificationService.getUserNotifications(undefined, undefined, undefined, 3, 0).subscribe((result) => {
            this.unreadNotificationCount = result.unreadCount;
            this.notifications = [];
            _forEach(result.items, (item: UserNotification) => {
                this.notifications.push(this._userNotificationHelper.format(<any>item));
            });
        });
    }

    registerToEvents() {
        let self = this;

        function onNotificationReceived(userNotification: abp.notifications.IUserNotification) {
            if (self.duplicateCache.some(dc => dc == userNotification.id)) {
                console.log("Notifications: Executing onNotificationsReceived id "+userNotification.id+" already known, ignoring");
                return;
            }

            self.addDuplicateCache(userNotification.id);

            if (typeof(userNotification.notification.creationTime) == "string") {
                userNotification.notification.creationTime = new Date(Date.parse(userNotification.notification.creationTime));
            }
            try {
                self._userNotificationHelper.show(userNotification);
                self.loadNotifications();
            }
            catch(e) {
                console.error("Notifications: FAILED onNotificationsReceived", e);
            }
        }

        this.subscribeToEvent('abp.notifications.received', (userNotification) => {
            self._zone.run(() => {
                onNotificationReceived(userNotification);
            });
        });

        function onNotificationsRefresh() {
            self.loadNotifications();
        }

        this.subscribeToEvent('app.notifications.refresh', () => {
            self._zone.run(() => {
                onNotificationsRefresh();
            });
        });

        function onNotificationsRead(userNotificationId) {
            for (let i = 0; i < self.notifications.length; i++) {
                if (self.notifications[i].userNotificationId === userNotificationId) {
                    self.notifications[i].state = 'READ';
                    self.notifications[i].isUnread = false;
                }
            }

            self.unreadNotificationCount -= 1;
        }

        this.subscribeToEvent('app.notifications.read', (userNotificationId) => {
            self._zone.run(() => {
                onNotificationsRead(userNotificationId);
            });
        });
    }

    addDuplicateCache(id: string) {
        this.duplicateCache.push(id);
        while (this.duplicateCache.length > 10) {
            this.duplicateCache.shift();
        }
    }

    setAllNotificationsAsRead(): void {
        this._userNotificationHelper.setAllAsRead();
    }

    openNotificationSettingsModal(): void {
        this._userNotificationHelper.openSettingsModal();
    }

    setNotificationAsRead(userNotification: IFormattedUserNotification): void {
        if (userNotification.state !== 'READ') {
            this._userNotificationHelper.setAsRead(userNotification.userNotificationId);
        }
    }

    gotoUrl(url): void {
        if (url) {
            location.href = url;
        }
    }
}
